import { warning } from "@jutro/logger";
export default function loadGtag(measurementId) {
  if (!measurementId) return warning("To enable gtag.js provide measurement id"), null;
  var scriptElement = document.createElement("script");
  function gtag() {
    window.dataLayer.push(arguments);
  }
  return scriptElement.src = "https://www.googletagmanager.com/gtag/js?id=".concat(measurementId), document.getElementsByTagName("head")[0].appendChild(scriptElement), window.dataLayer = window.dataLayer || [], gtag("js", new Date()), gtag("config", measurementId), gtag;
}